var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgFacial = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facial_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 0.752,
    y: 0.5,
    fill: "url(#facial_svg__b)",
    rx: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 0.752,
    y: 0.5,
    fill: "url(#facial_svg__c)",
    rx: 7
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6728FF",
    d: "M.752.5h14v14h-14z",
    opacity: 0.4,
    style: {
      mixBlendMode: "color"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.518 7.451c.158.096.158.362 0 .457L6.32 10.456c-.145.087-.317-.037-.317-.229V5.132c0-.192.172-.316.317-.228l4.2 2.547Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "facial_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-126.431 11.858 4.868)scale(24.3607 36.2338)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#FF1B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.437,
    stopColor: "#D502F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#C500E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#904BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "facial_svg__c",
    x1: 5.61,
    x2: 10.279,
    y1: 15.357,
    y2: 7.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FF6930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#FE3B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3B36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "facial_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 0.752,
    y: 0.5,
    fill: "currentColor",
    rx: 7
  })))));
});
SvgFacial.displayName = "SvgFacial";
export default SvgFacial;